// extracted by mini-css-extract-plugin
export default {"headingWrapper":"Header_headingWrapper__7eKOp","heading":"Header_heading__oc9-S"};